import { useAsyncDataRequestStatus } from '@/composables/utils/useAsyncDataRequestStatus';
import { useMicroCMSDetailParams } from '@/composables/utils/useMicroCMSDetailParams';
import type { EnStoryResponse, EnStoryViewModel } from '@/models/enStory';
import { createDefaultEnStoryState } from '@/models/enStory';
import { useMicroCMSGetListDetail } from '@/wabunka-src/common/composables/query/useMicroCMSClient';

import type { AsyncDataRequestStatus } from '#app';

/**
 * pathとqueryからdedupe用のkeyの組み立てを行う
 */
const buildKey = (path: string, query?: object) => {
  return path + (query ? ',query=' + JSON.stringify(query) : '');
};

/**
 * 英語版ストーリ詳細の取得に使用する Composable
 */
export const useEnStory = async () => {
  const { contentId, draftKeyQuery } = useMicroCMSDetailParams();

  const { data, status }: { data: Ref<EnStoryResponse | null>; status: Ref<AsyncDataRequestStatus> } = await useMicroCMSGetListDetail<EnStoryResponse>(
    {
      endpoint: 'en-stories',
      contentId: contentId.value,
      queries: { ...draftKeyQuery?.value },
    },
    {
      key: buildKey(`en-story-${contentId.value}`, { ...draftKeyQuery?.value }),
      server: true,
    },
  );

  const enStory = computed<EnStoryViewModel>(() => data.value || createDefaultEnStoryState());

  return { enStory, ...useAsyncDataRequestStatus(status) };
};
